import { render, staticRenderFns } from "./SupervisionHistoryList.vue?vue&type=template&id=058a81f5&scoped=true&"
import script from "./SupervisionHistoryList.vue?vue&type=script&lang=js&"
export * from "./SupervisionHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./SupervisionHistoryList.vue?vue&type=style&index=0&id=058a81f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058a81f5",
  null
  
)

export default component.exports